import React, { useCallback, useMemo } from "react";
import { Tag } from "antd";
import moment from "moment";
import { ShipmentStatusMap, IncompleteStatusMap, InvoiceStatusMap, BillStatusMap, VehicleTypeMap, SecurePassAutoSendMap, SECURE_PASS_TAG_STATUS_MAP, SecurePassLogTypeMap, ShipmentLockedMap, NissanVehicleStatusMap, } from "@/utils/enum";
import { cleanObjectFromUndefined } from "@/utils/utils";
import { DATE_KEYS } from "@/components/SortAndFilter/DateRangeFilter";
import { filterName, filterValueText, flagStatusNames, renamedColumns, sortToUserFriendly } from "./constants";
const filtersWithoutTag = ["page", "pageSize", "filter"];
const FilterTags = ({ filters, stateNames, dealersName, entityGroupNames, transportersName, managersName, sortingSeparator = ":", columnNames, onRemoveFilter, onRemoveSorting, }) => {
    const onClose = useCallback((filterKey, value) => {
        if (filterKey === "sorting") {
            onRemoveSorting?.();
        }
        else {
            onRemoveFilter?.(filterKey, value);
        }
    }, [onRemoveFilter, onRemoveSorting]);
    const filterKeys = useMemo(() => Object.keys(cleanObjectFromUndefined(filters))
        .filter(filterKey => !filtersWithoutTag.includes(filterKey))
        .map(filterKey => filterKey)
        .sort((a) => (a === "sorting" ? 1 : -1)), [filters]);
    return (React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 10 } }, filterKeys.map(filterKey => {
        let values = [];
        let name = renamedColumns[filterKey] || filterName[filterKey];
        let value = filters[filterKey];
        const originalValue = value;
        value = filterValueText[value] || value;
        if (name === undefined) {
            return null;
        }
        if (["stateId", "pickupStateId", "dropOffStateId"].includes(filterKey)) {
            value = stateNames[value];
        }
        else if (filterKey === "stateIds") {
            values = (value || []).map((stateId) => ({
                value: stateNames[stateId],
                originalValue: stateId,
            }));
        }
        else if (["city", "pickupCity", "dropOffCity"].includes(filterKey)) {
            // keeps the same value
        }
        else if (filterKey === "cities") {
            values = (value || []).map(city => ({
                value: city,
                originalValue: city,
            }));
        }
        else if (filterKey === "flagStatus") {
            value = flagStatusNames[value];
        }
        else if (filterKey === "dealerId") {
            value = dealersName[value];
        }
        else if (filterKey === "rating") {
            if (value === -1) {
                value = `Not Rated`;
            }
            else {
                value = `${value} Stars`;
            }
        }
        else if (filterKey === "companyGroupId") {
            value = entityGroupNames[value];
        }
        else if (Object.values(DATE_KEYS).includes(filterKey)) {
            const [start, end] = value ? value.split("/") : [];
            if (start && end) {
                value = `${moment(start).format("DD/MM/YYYY")} - ${moment(end).format("DD/MM/YYYY")}`;
            }
        }
        else if (filterKey === "shipmentStatus") {
            value = ShipmentStatusMap[value];
        }
        else if (filterKey === "incompleteStatus") {
            value = IncompleteStatusMap[value];
        }
        else if (filterKey === "billStatus") {
            value = BillStatusMap[value];
        }
        else if (filterKey === "invoiceStatus") {
            value = InvoiceStatusMap[value];
        }
        else if (filterKey === "transporterId") {
            value = transportersName[value];
        }
        else if (filterKey === "vehicleType") {
            value = VehicleTypeMap[value];
        }
        else if (filterKey === "managerId") {
            value = managersName[value];
        }
        else if (filterKey === "securePassAutoSendType") {
            value = SecurePassAutoSendMap[value];
        }
        else if (filterKey === "securePassValue") {
            value = SECURE_PASS_TAG_STATUS_MAP[value];
        }
        else if (filterKey === "securePassLogType") {
            value = SecurePassLogTypeMap[value];
        }
        else if (filterKey === "sorting") {
            const sortParts = value.split(sortingSeparator);
            const sortKey = sortParts[0];
            const sortValue = sortParts[1];
            name = columnNames?.[sortKey] || sortKey;
            value = sortToUserFriendly[sortValue] || sortValue;
        }
        else if (filterKey === "shipmentLocked") {
            value = ShipmentLockedMap[value];
        }
        else if (filterKey === "nissanVehicleStatus") {
            value = NissanVehicleStatusMap[value];
        }
        if (values.length === 0) {
            values = [{ value: value, originalValue: originalValue }];
        }
        return values.map(({ value: tagValue, originalValue: tagOriginalValue }) => tagValue !== undefined && (React.createElement(Tag, { closable: true, key: filterKey + tagOriginalValue, style: { borderColor: "silver", height: 25 }, onClose: () => onClose(filterKey, tagOriginalValue) },
            React.createElement("span", { style: { fontWeight: "bold", color: "black" } },
                `${name}:`,
                " "),
            React.createElement("span", null, tagValue))));
    })));
};
export default FilterTags;
